/**
 * The identifier for the core/data store.
 *
 * @type {string}
 */
export const STORE_NAME = 'core/data';
